import React from "react";
import one from './pics/one.jpeg';
import two from './pics/two.jpeg';
import './InterviewSV.css';

class InterviewSV extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-50-m w-50-l mw7 shadow-5 center">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                            <div className='legend center'>
                                <legend className="f1 fw6 ph0 mh0">الاوراق المطلوبة فى مقابلة السفارة بغرض الدراسة</legend>
                            </div>
                            <hr/>

                            <div className="ui form ma0">
                                <div className="fields">
                                    <div class="row">
                                        <div class="column">
                                            <img alt='' width='300px' height='400px' src={one} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='300px' height='400px' src={two} />
                                        </div>
                                    </div>

                                    <hr/>
                                    <h3>
                                        الاوراق المطلوبة فى المقابلة بغرض الدراسة للسفارة
                                        <br/>
                                        1- <a target='_blank' rel='noreferrer' href='https://kairo.diplo.de/blob/1587304/7b4b9309790df5d1fa748ee23816e449/antragsformular-deu-ara-data.pdf'>ابلكيشن السفارة</a>
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/504898626555529/'>ازاى تملى الابلكيشن</a>
                                        <br/>
                                        <br/>
                                        ______________________________________
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://kairo.diplo.de/blob/1587310/9c59c0e647ffcbc1780446630f340417/fotomustertafel-data.pdf'>و متنسوش ال 3 صور الشخصية</a>
                                        <br/>
                                        ______________________________________
                                        <br/>
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://kairo.diplo.de/blob/1587306/3eaba3624790048bd17cc45c14414e6c/rk-visa-belehrungsblatt-deu-arab-data.pdf'>2- الاقرار القانونى</a>
                                        <br/>
                                        <br/>
                                        3- لو هتدرس بالألمانى ولسا هتسافر تكمل لغة فلازم تجيب قبول من معهد لغة فى ألمانيا" لو خلصتها فخلاص مش هتجيب حاجة"
                                        <br/>
                                        اللى هيدرس بالانجليزى مالوش دعوة بالنقطة دى
                                        <br/>
                                        <br/>
                                        4- قبول الجامعة
                                        <br/>
                                        <br/>
                                        5- كشف حساب للحساب المغلق بتاعك فى المانيا او الاقرار للضامن او خطاب المنحة ان هى هتتكفل بمصاريفك
                                        <br/>
                                        <br/>
                                        6- شهادة اللغة لو معاك ألمانى او ايلتس
                                        <br/>
                                        <br/>
                                        7- صورة عادية من بيان درجات الثانوية "الصورة تكون متصورة من الشهادة المتوثقة "
                                        <br/>
                                        <br/>
                                        8- صورة عادية من بيان درجات الجامعة و يفضل كمان لو طالع بكالوريوس فيبقا معاك اثبات قيد لانهم اوقات بيطلبوها .. و لو طالع ماستر فزود شهادة التخرج + بيان الدرجات "الصور تكون متصورة من الشهادة المتوثقة "
                                        <br/>
                                        <br/>
                                        9- CV
                                        <br/>
                                        <br/>
                                        10- موتفيشن ليتر
                                        <br/>
                                        <br/>
                                        ______________________________________
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/404734919905234/'>CVلينك عن الموتفيشن و خطاب التوصية و ال</a>
                                        <br/>
                                        ______________________________________
                                        <br/>
                                        <br/>
                                        11- زى شهادة كورس / تطوع / خطاب توصية / تدريب / خبرة / اى ورقة معاك
                                        <br/>
                                        مش لازم يكونوا متوثقين سفارة بس لازم يكونوا انجليزى او المانى و ممضين من الجهة/الشخص اللى صادرة منه الشهادة
                                        <br/>
                                        <br/>
                                        12- صفحات الباسبور اللي فيها اختام + اول صفحتين اللي هي بياناتك وصفحة الامضاء
                                        <br/>
                                        <br/>
                                        ______________________________________
                                        **خلي دايما معاك نسخة احتياطي من كل الاوراق اللي معاك
                                        <br/>
                                        = الاصل مبيتاخدش منك.. بياخدوا نسختين صور عادية مش متوثقة و بيتأكدوا من الاصل
                                        <br/>
                                        وطبعا متنساش ٧٥ يورو مصاريف الفيزا و بياخدوا المبلغ فى الانترفيو و بتدفع المبلغ بالجنية المصرى
                                        <br/>
                                        والمبلغ لا يرد حتى لو اترفضت من السفارة
                                        <br/>
                                        تحديث
                                        10-2019
                                        <br/>
                                        فيه ورقة تانية نزلت و زادت عن القديمة "ورقة وثيقة التأمين" .. بس فيه اكتر من واحد قدم الانترفيو و متطلبش منه وثيقة التأمين ..
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/550735748638483/'>معلومات عن وثيقة التأمين</a>
                                    </h3>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </main>
            </article>
        );
    }
}

export default InterviewSV;
